import React, { useState, useMemo, useEffect } from "react";
import { ContactsOutlined } from "@ant-design/icons";
import { Descriptions, Divider, Tooltip } from "antd";
import { connect } from "dva";
import { formatPhoneNumber, copyToClipBoard, DEFAULT_ID } from "@/utils/utils";
import { getUserById } from "@/services/users_new";

const ShipperInfoTabPane = ({ adminShipmentView }) => {
  const [contactInfo, setContactInfo] = useState(null);

  const adminShipmentData = useMemo(() => adminShipmentView?.data, [adminShipmentView]);

  useEffect(() => {
    if (!adminShipmentData || adminShipmentData.contactShipperId === DEFAULT_ID) {
      return;
    }

    getUserById(adminShipmentData.contactShipperId).then(user => setContactInfo(user));
  }, [adminShipmentData]);

  return (
    <>
      <Descriptions
        title={
          <Tooltip color="#fff" title="Copy to clipboard">
            <span
              onClick={() => copyToClipBoard(adminShipmentData?.dealer?.name)}
              style={{
                marginLeft: 5,
                cursor: "pointer",
              }}
            >
              {adminShipmentData?.dealer?.name}
            </span>
          </Tooltip>
        }
        contentStyle={{ marginBottom: 0 }}
        column={1}
      >
        <Descriptions.Item key="address" label="Address" style={{ paddingBottom: 0 }}>
          {adminShipmentData?.dealer?.completedAddress}
        </Descriptions.Item>
        <Descriptions.Item key="phone" label="Phone" style={{ paddingBottom: 0 }}>
          {formatPhoneNumber(adminShipmentData?.dealer?.phoneNumber, adminShipmentData?.dealer?.phoneExt)}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
      <p>
        <ContactsOutlined /> Shipper Contact
      </p>
      <Descriptions column={1} title={contactInfo ? contactInfo.fullName : "N/A"}>
        <Descriptions.Item key="email" style={{ paddingBottom: "0" }}>
          {contactInfo && contactInfo.email}
        </Descriptions.Item>
        <Descriptions.Item key="phone" style={{ paddingBottom: "0" }}>
          {contactInfo && formatPhoneNumber(contactInfo.phoneNumber, contactInfo.phoneExt)}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
}))(ShipperInfoTabPane);
